import axios from "axios";
import { API_URL, API_URL_ANGULAR, API_URL_ESV } from "./Constant";
import { runQCApiPost } from "../actions/sendReports";
import { saveLogToS3 } from "./loggingService";
import {
  getUser,
  signOut,
  fetchEsvAuthToken,
} from "./helpers";

/**
* After every generatebatchreports/ call, if the "disableRunQc" is false
* then run qc on the current ui-overhaul backend.
* In migration, every generatebatchreports/ call, if the "disableRunQc" is false
* then run qc on the current ui-overhaul backend.
*/
const checkRunQc = (response) => {
  const requestUrl = response.config.url;
  // Handle current production run qc
  if (requestUrl.includes(API_URL) && requestUrl.includes("/generatebatchreports/")) {
    const apiPayload = JSON.parse(response.config.data);
    if (apiPayload.disableRunQc === false) {
      runQCApiPost({ rerun: false, workorder_id_list: apiPayload.list.map((item) => ({ wo_id: item.wo_id })) });
    }
  }
};

const handleInterceptAutomationResponse = async (response) => {
  checkRunQc(response);
  saveLogToS3(response);
};

/**
 * Intercept every ESV request and fetch the ESV auth token from SMS side.
 * Add the ESV auth token to the request headers and the company details to the request data/params
 */
const handleInterceptEsvRequest = async (request) => {
  const esvAuthResponse = await fetchEsvAuthToken();
  if (esvAuthResponse.success) {
    const {
      id_token, company_domain, company_name, admin_user_payload,
    } = esvAuthResponse;

    // Add the ESV auth token to the request headers and the company details to the request data/params
    request.headers.Authorization = `Bearer ${id_token}`;
    const key = request.method === "get" ? "params" : "data";
    if (!request[key]) {
      request[key] = {};
    }
    request[key].user_payload = admin_user_payload;
    request[key].company_name = company_name;
    request[key].company_domain = company_domain;

    return request;
  }
  // Reject with a proper axios error so calling code can handle it
  const errorMessage = esvAuthResponse.message || "Failed to fetch ESV auth token";
  const error = new Error(errorMessage);
  error.config = request;
  error.isAxiosError = true;
  return Promise.reject(error);
};

/**
 * Intercept every SMS automation request and add the user auth token to the request headers
 */
const handleInterceptSmsAutomationRequest = async (request) => {
  const skippedUrls = [
    "users/login/", // SMS login api doesn't require auth token
    "get_presigned_url_server/",
  ];
  // Add SMS auth token only for SMS and Automation URLs and not for the skipped paths
  if (!skippedUrls.some((url) => request.url.includes(url)) && [API_URL, API_URL_ANGULAR].some((url) => request.url.includes(url))) {
    const { token } = getUser();
    request.headers.Authorization = `Token ${token}`;
  }
  return request;
};

/** Use the request interceptor to add the loggin user auth token and ESV auth token */
export const axiosRequestInterceptor = () => {
  axios.interceptors.request.use(async (request) => {
    if (request.url.includes(API_URL_ESV)) {
      return handleInterceptEsvRequest(request);
    }
    return handleInterceptSmsAutomationRequest(request);
  }, (error) => {
    console.log("request error", error);
    return Promise.reject(error);
  });
};

export const axiosResponseInterceptor = () => {
  axios.interceptors.response.use((response) => {
    handleInterceptAutomationResponse(response);
    return response;
  }, (error) => {
    handleInterceptAutomationResponse(error);
    // If user sign outs in Angular, then we also need to sign out user in Automation
    if (error?.response?.status === 401) {
      signOut("?type=unauthorized");
    }
    console.error("Interceptor response error: ", error);
    throw (error);
  });
};
